export default __webpack_public_path__ + "static/media/media-and-entertainment.9361c6c1.png";